import { useContext } from 'react'
import { Button } from 'antd'
import i18next from 'i18next'

import { formatDate } from '../utils/utils'
import { getProductTypesList } from '../network/ProductTypes'
import { AppContext } from '../context/AppContext'

import PageWrap from '../components/layout/PageWrap'
import TableBlock from '../components/tables/TableBlock'
import DynamicStrings from '../components/DynamicStrings'

const canEditProductType = (role) =>
    role === 'super-admin' || role === 'admin' || role === 'product-manager'

const ProductTypes = ({ history }) => {
    const { user } = useContext(AppContext)

    return (
        <PageWrap title="MENU_PRODUCT_TYPES">
            <TableBlock
                columns={columns}
                filters={filters}
                name={'getProductTypesList'}
                request={getProductTypesList}
                pageSize={80}
                onRow={(record) => {
                    if (!canEditProductType(user.role)) {
                        return {}
                    }

                    return {
                        onClick: () => {
                            history.push(`/product-types/${record.id}`)
                        },
                    }
                }}
            />
        </PageWrap>
    )
}

const filters = (history) => ({
    fields: [
        {
            type: 'text',
            label: 'PRODUCT_TYPES_TYPE_NAME',
            key: 'name',
        },
    ],
    actions: [
        {
            label: 'PRODUCT_TYPES_CREATE',
            component: () => <BtnCreate history={history} />,
        },
    ],
})

const BtnCreate = ({ history }) => {
    const { user } = useContext(AppContext)

    if (!canEditProductType(user.role)) {
        return null
    }

    return (
        <Button
            type="primary"
            onClick={() => history.push('/product-types/create')}
        >
            <DynamicStrings id={'PRODUCT_TYPES_CREATE'} />
        </Button>
    )
}

const getTypeName = (name) =>
    typeof name === 'string'
        ? name
        : name?.[i18next.language] || name?.en || name?.zh || ''

const columns = () => [
    {
        title: <DynamicStrings id="PRODUCT_TYPES_TYPE_NAME" />,
        dataIndex: 'name',
        key: 'name',
        render: (name) => getTypeName(name),
        sorter: true,
    },
    {
        title: <DynamicStrings id="PRODUCT_TYPES_CATEGORY" />,
        dataIndex: 'category',
        key: 'category',
        render: (category) =>
            category ? <DynamicStrings id={category} /> : null,
        sorter: true,
    },
    {
        title: <DynamicStrings id="DELIVERY_TEMPLATES_CREATED_DATE" />,
        dataIndex: 'createdAt',
        key: 'createdAt',
        render: (date) => (date ? formatDate(date) : null),
        sorter: true,
    },
]

export default ProductTypes
